import React from 'react'
import styles from './LabeledContainer.module.scss'
import { LabeledContainerProps } from './LabeledContainer.types'
import cl from 'classnames'

const LabeledContainerComponent = (props: LabeledContainerProps) => {
  const {
    label,
    children,
    className
  } = props

  return (
    <div className={cl(styles.container, className)}>
      {label && <label>{label}<span /></label>}
      <div>
        {children}
      </div>
    </div>
  )
}

const LabeledContainer = LabeledContainerComponent
export { LabeledContainer }
